import Auth from '@js/plugins/auth';

export function abortIfNotPermitted(permission, next) {
    if (Auth.hasPermissionTo(permission)) {
        next();
        return;
    }

    next(false);
}

/**
 * Only allow access if:
 * - The user is from Batcave OR
 * - The user has the required permission
 */
export function abortIfRequiresSubscription(permission, next) {
    const adminCanManage = Auth.hasPermissionTo('admin_manage_outlets');

    const userCanManage = Auth.hasPermissionTo(permission);

    if (adminCanManage || userCanManage || Auth.canExtendAccount()) {
        next();
        return;
    }

    next(false);
}
